import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Saad Mehmood </span>
            from <span className="purple"> Lahore, Pakistan.</span>
            <br />I am a Software Engineer with core strength in MERN stack .
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "I can turn your Ideas into code but don't ask me how!!!"{" "}
          </p>
          <footer className="blockquote-footer">Saad Mehmood</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
